import { isLiveBlogPage } from '../../utils/aem-utils';

const PLAYER_CONTAINER_CLASS_NAME = '.j-intro .o-aspect-ratio--16-9';
const GLOBAL_NAV_CLASS_NAME = '.c-global-nav';
const SECTION_DIVIDER_SPECIAL_CLASS_NAME = '.c-section-divider--special .c-section-divider__image';
export const PROGRESS_BAR_CLASSNAME_SELECTOR = '.c-reading-progress-bar';
export const MEDIA_WRAPPER_TOP_BG_CLASSNAME = 'c-hero__media-wrapper--top-bg';
export const PLAYER_CLOSE_BUTTON_CLASSNAME = 'c-player-card__close';
export const HERO_STICKY_PLAYER_WRAPPER_CLASSNAME = 's-hero-sticky-player-wrapper';
export const HERO_STICKY_PLAYER_WRAPPER_LMP_CLASSNAME = 's-hero-sticky-player-wrapper-lmp';

export const $playerContainer = document.querySelector(PLAYER_CONTAINER_CLASS_NAME);
export const $globalNav = document.querySelector(GLOBAL_NAV_CLASS_NAME);
export const $sectionDividerSpecial = document.querySelector(SECTION_DIVIDER_SPECIAL_CLASS_NAME);
export const $intro = document.querySelector('.j-intro');
export const $player = $intro?.querySelector('.j-player');
export const $heroStickyPlayerWrapper = $intro?.querySelector('.j-player')?.parentElement;
export const $LMPHero = document.querySelector('.ftbl__hero-lmp');
export const $F1Hero = document.querySelector('.ftbl__lgp-hero-container.j-intro');
export const $LMPPlayerWrapperMobile =
  document.querySelector('.ftbl__hero-lmp--content-wrapper') ||
  document.querySelector('.ftbl__lgp-hero__img-video-container');
export const MOBILE_STICKY_WRAPPER_TOP_VALUE = isLiveBlogPage() ? 61 : 65;
